import { cn } from "@/lib/utils";
import { useTranslation } from "@repo/shared/i18n";

interface ContentTagProps {
  contentType:
    | "player"
    | "market"
    | "evolution"
    | "sbc"
    | "club"
    | "objective"
    | "gallery"
    | "squadBuilder";
}

const COLORS: Record<ContentTagProps["contentType"], string> = {
  player: "text-amber-400 bg-amber-900/50",
  // Players to buy: the player colour, named for where they come from.
  market: "text-amber-400 bg-amber-900/50",
  evolution: "text-emerald-400 bg-emerald-900/50",
  sbc: "text-indigo-400 bg-indigo-900/50",
  club: "text-sky-400 bg-sky-900/50",
  objective: "text-fuchsia-400 bg-fuchsia-900/50",
  gallery: "text-gallery bg-purple-900/50",
  squadBuilder: "text-teal-400 bg-teal-900/50",
};

export const ContentTag = ({ contentType }: ContentTagProps) => {
  const { t } = useTranslation("common");
  return (
    <div
      className={cn(
        "rounded-full px-2 h-5 flex items-center justify-center",
        COLORS[contentType],
      )}
    >
      <span className="text-xs leading-0">
        {t(`contentTag.${contentType}` as const)}
      </span>
    </div>
  );
};
